export default __webpack_public_path__ + "static/media/check-circle.1abd1579.svg";